import { createContext } from "react";

import type { Severity } from "./types";
import { DEFAULT_SEVERITY } from "./utils";

type AlertContextProps = {
    severity: Severity;
};

export const AlertContext = createContext<AlertContextProps>({
    severity: DEFAULT_SEVERITY,
});
